import { useEffect } from 'react';
import { analytics } from '../lib/analytics';
import { useLocation } from './useLocation';

export function useAnalytics(userId?: string) {
  const location = useLocation();

  useEffect(() => {
    analytics.init(userId);
  }, [userId]);

  useEffect(() => {
    analytics.trackPageView(location.pathname);
  }, [location]);

  return analytics;
}